"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioStateMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _hoverMediaQueryMixin = require("./hoverMediaQueryMixin");
var defaultCSS = function defaultCSS(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Radio.backgroundColor',
    borderColor: 'Radio.borderColor',
    borderColorHover: 'Radio.borderColorHover',
    borderColorDisabled: 'Radio.borderColorDisabled',
    borderRadius: 'radii.ellipse',
    borderWidth: 'Radio.borderWidth',
    focusBoxShadow: 'shadows.focus',
    size: 'Radio.size'
  }, function (tokens) {
    return (0, _styledComponents.css)(["appearance:none;outline:none;box-shadow:none;box-sizing:border-box;display:inline-block;height:", "px;width:", "px;background:", ";border:", "px solid ", ";border-radius:", ";cursor:pointer;margin:0;transition:border-color 200ms ease-in-out,background-color 200ms ease-in-out;"], tokens.size, tokens.size, tokens.backgroundColor, tokens.borderWidth, props.disabled || props['aria-disabled'] ? tokens.borderColorDisabled : tokens.borderColor, tokens.borderRadius);
  })(props);
};
var hoverCSS = function hoverCSS(props) {
  return (0, _styledToken.default)({
    borderColorHover: 'Radio.borderColorHover'
  }, function (tokens) {
    return (0, _styledComponents.css)(["border-color:", ";"], tokens.borderColorHover);
  })(props);
};
var pressedCSS = function pressedCSS(props) {
  return (0, _styledToken.default)({
    borderColorPressed: 'Radio.borderColorPressed'
  }, function (tokens) {
    return (0, _styledComponents.css)(["border-color:", ";"], tokens.borderColorPressed);
  })(props);
};
var checkedCSS = function checkedCSS(props) {
  return (0, _styledToken.default)({
    borderColorActive: 'Radio.borderColorActive',
    borderColorActiveHover: 'Radio.borderColorActiveHover',
    borderColorActivePressed: 'Radio.borderColorActivePressed',
    borderWidth: 'Radio.borderWidthChecked'
  }, function (tokens) {
    return (0, _styledComponents.css)(["border-color:", ";border-width:", "px;", ";&:active:not(:disabled){border-color:", ";}"], tokens.borderColorActive, tokens.borderWidth, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n        border-color: " + tokens.borderColorActiveHover + ";\n      "), tokens.borderColorActivePressed);
  })(props);
};
var focusCSS = function focusCSS(props) {
  return (0, _styledToken.default)({
    boxShadow: 'shadows.focus'
  }, function (tokens) {
    return (0, _styledComponents.css)(["box-shadow:", ";"], tokens.boxShadow);
  })(props);
};

/** @mixin radioStateMixin */
/** @method */
var radioStateMixin = function radioStateMixin(state) {
  return function (props) {
    switch (state) {
      case 'hover':
        return hoverCSS(props);
      case 'pressed':
        return pressedCSS(props);
      case 'checked':
        return checkedCSS(props);
      case 'focus':
        return focusCSS(props);
      default:
        return defaultCSS(props);
    }
  };
};
exports.radioStateMixin = radioStateMixin;